import { useHingeHealthSecurityContext } from '@hinge-health/react-component-library';
import { OktaRole } from '../../../utils/okta-roles';

/**
 * Pure check: does this set of Okta role claims grant Billing Write access?
 * Exported separately from the hook so it can be unit-tested without React.
 */
export const hasBillingWriteAccess = (roles: unknown): boolean =>
  Array.isArray(roles) && roles.map(String).includes(OktaRole.BILLING_WRITE);

/**
 * True when the current user holds the Billing Write role.
 *
 * Read-only (Billing Read) users get `false`, which is used to hide mutation
 * triggers and guard write-only routes within the billing tool. Both roles
 * already share the same routes, so view access is assumed for anyone who
 * reached the module — this only distinguishes read from write.
 *
 * Note: this is a UX guard, not a security boundary. The server must still
 * reject writes from read-only principals.
 */
export const useBillingWriteAccess = (): boolean => {
  const { hingeHealthAuthState } = useHingeHealthSecurityContext();
  return hasBillingWriteAccess(
    hingeHealthAuthState?.accessToken?.claims?.roles,
  );
};
